export default __webpack_public_path__ + "static/media/dice.12e19ba5.png";